import styles from './input-day.module.css'

export const generateButtonClasses = (isActive: boolean) => {
  return `${styles.button} ${isActive ? styles['button-active'] : ''}`
}
